import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Carousel from "react-bootstrap/Carousel";
import classNames from "classnames";
import { useStyles } from "./styles";
const CarouselComponent = forwardRef(
  ({ data, name, className, ...rest }, ref) => {
    const classes = useStyles();
    return (
      <div className={classNames(classes.slider, "sliderCommon")}>
        <Carousel
          data-bs-theme="dark"
          indicators={true}
          controls={true}
          className={className}
        >
          {data && data.company_logo && data.company_logo_url && (
            <Carousel.Item>
              <img
                src={data.company_logo_url}
                alt="Company Logo"
              />
            </Carousel.Item>
          )}
          {data.image_data.map((item, i) => (
            <Carousel.Item>
              <img
                src={item.image_url}
                alt={`${i} Slide`}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  }
);

CarouselComponent.propTypes = {
  name: PropTypes.string.isRequired,
};

export default CarouselComponent;
